export default __webpack_public_path__ + "static/media/carE-1.1e9354d1.png";